import { HStack, Stack, Text, VStack } from 'native-base';
import React, { useMemo } from 'react';
import NewLoanInProgressHeader from '../NewLoanInProgressHeader';
import Functions from '../../../utils/Functions';
import BorderedCard from '../../BorderedCard';
const LoanOverviewComponent = props => {
  const {
    loanOverviewData: {
      terms
    },
    statusCode
  } = props;
  const {
    baseLoanAmount,
    noteRatePercent,
    mortgageType,
    APR
  } = useMemo(() => {
    let result = {
      baseLoanAmount: 0,
      noteRatePercent: 0,
      mortgageType: '',
      APR: 0
    };
    if (Array.isArray(terms) && terms.length) {
      const [first] = terms;
      if (first) {
        result = {
          baseLoanAmount: first.baseLoanAmount,
          noteRatePercent: first.noteRatePercent,
          APR: first.extensions.other.APR,
          mortgageType: first.mortgageType
        };
      }
    }
    return result;
  }, [terms]);
  return /*#__PURE__*/React.createElement(BorderedCard, {
    border: "border.primary",
    pt: "3",
    pb: "4",
    px: "5",
    testID: "loan-summary-root"
  }, /*#__PURE__*/React.createElement(VStack, {
    space: "5"
  }, /*#__PURE__*/React.createElement(NewLoanInProgressHeader, {
    header: "Loan Summary"
  }), /*#__PURE__*/React.createElement(Stack, {
    justifyContent: {
      md: 'space-between',
      base: undefined,
      lg: undefined
    },
    direction: {
      base: 'column',
      md: 'row',
      lg: 'column'
    },
    space: "1"
  }, !terms || !Array.isArray(terms) || terms.length === 0 ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HStack, {
    space: {
      base: 7,
      md: 3,
      lg: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "text.running",
    fontSize: "sm",
    fontWeight: "normal",
    fontFamily: "body",
    minWidth: {
      lg: 82,
      md: undefined,
      base: 82
    },
    accessibilityLabel: "product type",
    testID: "product-type"
  }, "Product Type"), /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm",
    fontWeight: "normal",
    fontFamily: "body",
    color: "text.running",
    accessibilityLabel: mortgageType,
    testID: mortgageType
  }, mortgageType)), /*#__PURE__*/React.createElement(HStack, {
    space: {
      base: 7,
      md: 3,
      lg: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "text.running",
    fontSize: "sm",
    fontWeight: "normal",
    fontFamily: "body",
    minWidth: {
      lg: 82,
      md: undefined,
      base: 82
    },
    accessibilityLabel: "rate",
    testID: "rate"
  }, "Rate"), statusCode >= 11 ? /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm",
    fontWeight: "normal",
    fontFamily: "body",
    color: "text.running",
    accessibilityLabel: `${Number(noteRatePercent).toFixed(2)}% (
                        ${Number(APR).toFixed(2)}% APR)`,
    testID: `${Number(noteRatePercent).toFixed(2)}% (
                        ${Number(APR).toFixed(2)}% APR)`
  }, `${Number(noteRatePercent).toFixed(2)}% `, APR || APR === 0 ? `(${Number(APR).toFixed(2)}% APR)` : null) : null), /*#__PURE__*/React.createElement(HStack, {
    space: {
      base: 7,
      md: 3,
      lg: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "text.running",
    fontSize: "sm",
    fontWeight: "normal",
    fontFamily: "body",
    minWidth: {
      lg: 82,
      md: undefined,
      base: 82
    },
    accessibilityLabel: "Loan Amount",
    testID: "loan-amount"
  }, "Loan Amount"), /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm",
    fontWeight: "normal",
    fontFamily: "body",
    color: "text.running",
    accessibilityLabel: `${Functions.toUSD(baseLoanAmount)}`,
    testID: `${Functions.toUSD(baseLoanAmount)}`
  }, Functions.toUSD(baseLoanAmount)))))));
};
export default /*#__PURE__*/React.memo(LoanOverviewComponent);
//# sourceMappingURL=index.js.map